<ion-header translucent="true">
    <!-- <ion-toolbar> -->
        <!-- <ion-buttons slot="start">
            <ion-button>Contact Support</ion-button>
        </ion-buttons> -->

        <!-- <ion-title color="primary" class="text-center">Badge Connect</ion-title> -->
        <!-- <ion-buttons slot="end">
            <ion-button >
                <ion-icon slot="icon-only" name="search"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    <!-- </ion-toolbar> -->
    <ion-toolbar>
        <div class="flex-center">
            <img class="badge-img" src="assets/img/badge.png" alt="" >
        </div>
    </ion-toolbar>
    <ion-toolbar>
        <div class="text-center text-lg px-3 pt-3 font-bold">
            Connect to your Wire Badge
        </div>
        <div class="text-center text-xs px-3 pt-3 text3">
            Power on your Wire Badge and enter <i>Pairing Mode</i> (Settings > Bluetooth > On / Pairing). 
            Select your device from this list that matches your Badge Number. Then, enter the <i>Auth Pin</i> (Settings > Auth Pin) to connect your badge to the app.
        </div>
        <div class="flex-center opacity-50 my-2">
            <ion-button color="medium" fill="clear" size="small" (click)="support()">Contact Support</ion-button>
            <ion-button color="medium" fill="clear" size="small" (click)="tryLater()">Try Later</ion-button>
        </div>
    </ion-toolbar>
</ion-header>

<ion-content fullscreen="true">
    <ion-list *ngIf="ble.enabled; else bleNotEnabled">
        <ng-container *ngIf="ble.availableDevices.length > 0 && !ble.scanning; else noneFound">
            <ion-item lines="none" class="fadeInUp" *ngFor="let d of ble.availableDevices">
                <ion-label class="flex flex-col">
                    <h4>{{ d.name }}</h4>
                    <p class="text-xs">{{ d.deviceId }}</p>
                </ion-label>
                <ion-button *ngIf="!ble.connectedDevice || (ble.connectedDevice && ble.connectedDevice?.deviceId != d.deviceId)" slot="end" outline="true"
                (click)="connectToDevice(d)">Connect</ion-button>
                <ion-button *ngIf="ble.connectedDevice && ble.connectedDevice?.deviceId == d.deviceId" slot="end" outline="true"
                (click)="ble.disconnect(d.deviceId)">Disonnect</ion-button>
            </ion-item>
        </ng-container>
        <ng-template #noneFound>
            <div *ngIf="!ble.scanning" class="py-4 px-6 text-sm text2 text-center">
                No BLE devices found. Make sure your Wire Badge is powered on and in <i>Pairing Mode</i> (Settings > Bluetooth > On / Pairing) and try Scanning again.
            </div>
        </ng-template>
    </ion-list>

    <ng-template #bleNotEnabled>
        <div class="py-4 px-6 text-sm text-warning text-center">
            Unable to access Bluetooth Low Energy (BLE). Make sure Bluetooth is available on your Phone in order to connect to your Wire Badge. 
            Make sure that your Wire Badge is powered on and in pairing mode. 
            If there's an issue, restart your badge and app and try again. Otherwise, contact support. 
        </div>
    </ng-template>
</ion-content>

<ion-footer class="slideInUp">
    <ion-button expand="block" color="primary" (click)="ble.startScan()" [disabled]="ble.scanning || !ble.enabled">
        <ion-spinner color="white" name="circles" class="mr-2" *ngIf="ble.scanning"></ion-spinner>
        {{ ble.scanning ? 'Scanning' : 'Scan' }}
    </ion-button>
</ion-footer>